import { Result } from 'hevy-shared';
import { HTTPResponse, isHTTPError } from 'hevy-shared/API';
import { makeAutoObservable } from 'mobx';

class BackendReachabilityClass {
  backendReachabilityState: 'reachable' | 'unreachable' | 'maintenance-mode' = 'reachable';
  constructor() {
    makeAutoObservable(this);
  }

  handleResponse = (result: Result<HTTPResponse>) => {
    if (result.isSuccess) {
      this.backendReachabilityState = 'reachable';
      return;
    }

    if (!isHTTPError(result.error)) {
      // No response: unable to get a response at all from the backend (DNS failure, network failure, etc.)
      this.backendReachabilityState = 'unreachable';
      return;
    }

    const { response } = result.error;

    if (
      response.status === 503 &&
      typeof response.data === 'string' &&
      response.data.includes('maintenance')
    ) {
      // 503 response code with "maintenance" in the body: we're definitely in maintenance mode
      this.backendReachabilityState = 'maintenance-mode';
    } else {
      // We got a response that isn't maintenenace mode, so we're reachable (even if it's a non-200 response)
      this.backendReachabilityState = 'reachable';
    }
  };
}

export const BackendReachability = new BackendReachabilityClass();
